import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { FileText, ChevronDown, ChevronUp, Target, AlertCircle, Trophy } from 'lucide-react';

export default function SITREPCard() {
  const [isExpanded, setIsExpanded] = useState(false);

  // TODO: Replace with actual SITREP data
  const sitrep = {
    weeklyFocus: 'JavaScript fundamentals and first portfolio project',
    blockers: [
      'Need clarification on async/await concepts',
      'Project deployment setup pending'
    ],
    wins: [
      'Completed 3 modules ahead of schedule',
      'Built first functional web app',
      'Achieved 7/15 core skills milestone'
    ],
    nextMilestone: {
      title: 'Complete Task Manager Project',
      dueDate: 'End of Week 8',
      progress: 35
    }
  };

  return (
    <Card accent className="bg-card shadow-md border-border hover:shadow-lg transition-shadow">
      <CardHeader className="cursor-pointer hover:bg-muted/30 transition-colors" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg font-bold text-primary flex items-center gap-2">
            <div className="p-1.5 rounded-md bg-accent/10">
              <FileText className="h-5 w-5 text-accent" />
            </div>
            Weekly SITREP
          </CardTitle>
          {isExpanded ? (
            <ChevronUp className="h-5 w-5 text-primary transition-transform" />
          ) : (
            <ChevronDown className="h-5 w-5 text-primary transition-transform" />
          )}
        </div>
      </CardHeader>
      
      {isExpanded && (
        <CardContent className="space-y-4 pt-0">
          {/* Weekly Focus */}
          <div className="p-4 rounded-lg bg-primary/5 border-l-4 border-primary shadow-sm">
            <div className="flex items-start gap-3">
              <div className="p-1.5 rounded-md bg-primary/10 mt-0.5">
                <Target className="h-4 w-4 text-primary flex-shrink-0" />
              </div>
              <div>
                <p className="text-xs font-bold text-primary uppercase tracking-wide mb-1">Mission Focus</p>
                <p className="text-sm text-foreground font-medium">{sitrep.weeklyFocus}</p>
              </div>
            </div>
          </div>

          {/* Blockers */}
          {sitrep.blockers.length > 0 && (
            <div className="p-3 rounded-lg bg-destructive/5 border border-destructive/20">
              <div className="flex items-center gap-2 mb-3">
                <div className="p-1 rounded bg-destructive/10">
                  <AlertCircle className="h-4 w-4 text-destructive" />
                </div>
                <h4 className="text-sm font-bold text-destructive">Blockers</h4>
              </div>
              <ul className="space-y-2 ml-7">
                {sitrep.blockers.map((blocker, index) => (
                  <li key={index} className="text-sm text-foreground list-disc">{blocker}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Wins */}
          <div className="p-3 rounded-lg bg-primary/5 border border-primary/20">
            <div className="flex items-center gap-2 mb-3">
              <div className="p-1 rounded bg-primary/10">
                <Trophy className="h-4 w-4 text-primary" />
              </div>
              <h4 className="text-sm font-bold text-primary">Recent Wins</h4>
            </div>
            <ul className="space-y-2 ml-7">
              {sitrep.wins.map((win, index) => (
                <li key={index} className="text-sm text-foreground font-medium list-disc">{win}</li>
              ))}
            </ul>
          </div>

          {/* Next Milestone */}
          <div className="p-4 rounded-lg bg-secondary/5 border-l-4 border-secondary shadow-sm">
            <div className="flex items-start justify-between mb-2">
              <div>
                <p className="text-xs font-bold text-secondary uppercase tracking-wide">Next Major Milestone</p>
                <p className="text-sm font-bold text-foreground mt-1">{sitrep.nextMilestone.title}</p>
              </div>
              <Badge variant="branch" className="text-xs">{sitrep.nextMilestone.dueDate}</Badge>
            </div>
          </div>
        </CardContent>
      )}
    </Card>
  );
}
